import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";

const PHONE = "919598643434"; // +91 9598643434
const MESSAGE = "Hi Andrich Pharmaceuticals, I'd like to know more about your products.";

export default function WhatsAppFab() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab"
      className={`fixed z-40 bottom-6 right-6 flex items-center gap-2 pl-3 pr-4 py-3 rounded-full text-white shadow-2xl transition-all duration-500 ease-out
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
      style={{ background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)" }}
    >
      <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-white/15">
        <span className="absolute inset-0 rounded-full animate-ping bg-white/25" />
        <MessageCircle size={18} className="relative" strokeWidth={2.4} />
      </span>
      <span className="hidden sm:flex flex-col leading-tight">
        <span className="text-[0.65rem] uppercase tracking-[0.18em] opacity-90">Chat with us</span>
        <span className="text-sm font-semibold">WhatsApp</span>
      </span>
    </a>
  );
}
